import { Injectable } from '@angular/core';
import { AngularFirestore } from "@angular/fire/compat/firestore";
import firebase from "firebase/compat/app";
import { Observable } from "rxjs";
import { KavitaMOM } from "./counsellors-mom.model";

/**
 * Service for managing MOM with Kavita sessions
 */
@Injectable({
  providedIn: 'root'
})
export class KavitaMomService {
  private collection = this.firestore.collection<KavitaMOM>('Counselling/MOM/kavita-mom-sessions');

  constructor(private firestore: AngularFirestore) {}

  /**
   * Create a new Kavita MOM session
   * @param data The Kavita MOM session data
   */
  create(data: KavitaMOM): Promise<any> {
    const payload: KavitaMOM = {
      ...data,
      createdAt: firebase.firestore.FieldValue.serverTimestamp() as any,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp() as any,
    };
    return this.collection.add(payload);
  }

  /**
   * Get a Kavita MOM session by ID
   * @param id The session ID
   */
  getDataById(id: string): Observable<KavitaMOM | undefined> {
    return this.collection.doc<KavitaMOM>(id).valueChanges({ idField: 'id' });
  }

  /**
   * Get all Kavita MOM sessions
   */
  getAll(): Observable<KavitaMOM[]> {
    return this.collection.valueChanges({ idField: 'id' });
  }

  /**
   * Update a Kavita MOM session
   * @param id The session ID
   * @param data The updated data
   */
  update(id: string, data: Partial<KavitaMOM>): Promise<void> {
    const payload = {
      ...data,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    };
    return this.collection.doc(id).update(payload);
  }

  /**
   * Delete a Kavita MOM session
   * @param id The session ID
   */
  deleteRow(id: string): Promise<void> {
    return this.collection.doc(id).delete();
  }
}
